<div class="card card-statistics mb-30">
  <div class="card-body position-relative">
    <div class="error">
     <h1>404</h1>
     <h2>ارور</h2>
  </div>
</div>
<img class="img-fluid error-image" src="assets/Content/images/error.png" alt="">
</div>
